import { designTokens, IconButton, styled } from '@project44/manifest-ds';
import { Spinner, styled as uistyled } from '@project44/manifest-ui-deprecated';

export const StyledIconButton = styled(IconButton, {
  width: '2rem',
  height: '2rem',
  '& .icon': {
    fill: designTokens.colorTextPrimary,
  },
});

export const StyledLoadingIconButton = styled(IconButton, {
  border: `1px solid ${designTokens.colorPaletteGrey200}`,
  boxModel: 'border-box',
  boxShadow: 'none',

  width: '2rem',
  height: '2rem',

  '& .icon': {
    fill: designTokens.colorTextPrimary,
  },
});

export const StyledSpinner = uistyled(Spinner)({
  height: '16px',
  width: '16px',
  margin: '0 -4px',
});
